<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">快捷导航</span>
      </div>
      <el-row :gutter="0" align="left">
        <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="8">
              <span>可用余额：<span style="font-size: Medium;font-weight: bolder">{{ quicklyData.balanceMoney }}</span>元</span>
            </el-col>
            <el-col :span="6">
              <span>提现待审核资金：<span style="font-size: Medium">{{ quicklyData.freezeMoney }}</span></span>
            </el-col>
            <el-col :span="8">
              <router-link to="/home/cashdetail" >查看资金明细</router-link>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <span>店铺数：<span style="font-size: Medium">{{ quicklyData.shopsNumUsed }}/{{ quicklyData.shopsNumLimit }}</span>(已用/上限)</span>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-card>
    <div style="height: 1rem"></div>
    <el-card>
      <div slot="header" class="clearfix">
        <span style="color: #409EFF">我的邀请码</span>
      </div>

      <el-form ref="queryForm" :model="queryForm" label-width="260px">
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item prop="investMoney">
              <el-input type="textarea" v-model="queryForm.myqrcode" placeholder="http://ysj.taoxibao.top/login/Register?Code=EGTAQQ" readonly>
              </el-input>
              <span style="color: red">邀请好友注册成为商家，可获得订单服务费10.00%</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <div style="height: 1rem"></div>
    <business-message-list :is-show-search-bar="false"></business-message-list>
    <customer-service-component></customer-service-component>
  </div>
</template>

<script>
import businessMessageList from './BusinessMessagelist';
import {queryBusinessQuicklyData} from "../../api/b2cbusiness/b2c_allquicklydata";
import CustomerServiceComponent from "../../components/CustomerServiceComponent";
import {queryShareCode} from "../../api/b2cbusiness/b2c_sharecode";
export default {
  name: "BusinessFirstPage",
  components:{
    businessMessageList,
    CustomerServiceComponent
  },
  data() {
    return {
      quicklyData: {
      },
      queryForm: {
        myqrcode:"http://ysj.taoxibao.top/login/Register?Code=EGTAQQ"
      },
    }
  },
  mounted() {
    this.getData();
  },
  methods:{
    getData(){
      queryBusinessQuicklyData().then(res=>{
        if (res.success) {
          console.log(res.data);
          this.quicklyData = res.data;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
      queryShareCode().then(res=>{
        if (res.success){
          //this.queryForm.myqrcode = "https://api.weiquanai.com/register?sharecode="+res.data;
          this.queryForm.myqrcode = "http://sj.usmartdoc.com/register?sharecode="+res.data;
        }
      }).catch(err => {
        this.$message({message: err.message, type: 'error'});
      });
    }
  }
}
</script>

<style lang="scss" scoped>
span{
  color: red;
  span{
    margin: 5px;
    font-weight: bolder;
    font-size: 2rem;
  }
}

.el-form-item__content{
  line-height: 0;
}
</style>
